import { axiosInstance, API_PREFIX, type ApiResponse, type RequestParams } from '@/shared/api';
import type { ApiResponseList } from '@/shared/api/types';
import type { TaskBase, TaskCreatePayload, TaskUpdatePayload } from '../model/types';

const BASE = `${API_PREFIX.ADMIN_V1}/task`;

export const getList = async (params?: RequestParams): Promise<ApiResponseList<TaskBase>> => {
  const { data } = await axiosInstance.get<ApiResponseList<TaskBase>>(`${BASE}/index`, { params });
  return data;
};

export const getById = async (id: number): Promise<ApiResponse<TaskBase>> => {
  const { data } = await axiosInstance.get<ApiResponse<TaskBase>>(`${BASE}/show`, { params: { id } });
  return data;
};

export const create = async (payload: TaskCreatePayload): Promise<ApiResponse<TaskBase>> => {
  const { data } = await axiosInstance.post<ApiResponse<TaskBase>>(`${BASE}/create`, payload);
  return data;
};

export const update = async (payload: TaskUpdatePayload): Promise<ApiResponse<TaskBase>> => {
  const { data } = await axiosInstance.post<ApiResponse<TaskBase>>(`${BASE}/update`, payload);
  return data;
};

export const remove = async (id: number): Promise<ApiResponse<null>> => {
  const { data } = await axiosInstance.post<ApiResponse<null>>(`${BASE}/delete`, { id });
  return data;
};
